import type { PackageType } from "@b2bportal/core-packages";
import { usePackagesStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CorePackagesComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { RadioGroup } from "@tenant/ui";
import clsx from "clsx";
import { usePackageSelectRadioGroup } from "./hook";
import defaultStyles from "./PackageSelectRadioGroup.module.scss";

const COMPONENT_KEY = CorePackagesComponent.PackageSelectRadioGroup;

export interface PackageSelectRadioGroupProps extends PlatformComponentProps {
  onSelectValue: (value: PackageType) => void;
  selectedOption: PackageType;
}

export const PackageSelectRadioGroup = ({
  className,
  onSelectValue,
  selectedOption,
}: PackageSelectRadioGroupProps) => {
  const styles = usePackagesStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const {
    context: { packageTypeOptions },
  } = usePackageSelectRadioGroup();

  return (
    <RadioGroup
      className={clsx(block, className)}
      onSelectValue={(value) => onSelectValue(value as PackageType)}
      options={packageTypeOptions}
      selectedOption={selectedOption}
    />
  );
};
